/**
 * "Why this book" chips for the /reranker views, derived from the
 * purchase-history features so a reviewer sees them without opening Details.
 * Next volume supersedes series started: it is the stronger, narrower claim.
 */
import { useTranslation } from 'react-i18next';
import type { AffinityBookRow } from '../services/api';

export type AffinityReason = 'next_volume' | 'series_started' | 'author_in_history';

export function historyReasons(row: AffinityBookRow): AffinityReason[] {
  const value = (key: string) => row.features[key] ?? 0;
  const reasons: AffinityReason[] = [];
  if (value('is_next_volume') > 0) {
    reasons.push('next_volume');
  } else if (value('series_started') > 0) {
    reasons.push('series_started');
  }
  if (value('author_in_history') > 0) {
    reasons.push('author_in_history');
  }
  return reasons;
}

export default function AffinityReasons({
  row,
  size = 'sm',
}: Readonly<{ row: AffinityBookRow; size?: 'xs' | 'sm' }>) {
  const { t } = useTranslation();
  const reasons = historyReasons(row);
  if (reasons.length === 0) return null;
  const text = size === 'xs' ? 'text-[10px] px-1.5' : 'text-xs px-2';
  return (
    <div className="flex flex-wrap gap-1">
      {reasons.map((reason) => (
        <span
          key={reason}
          className={`inline-block rounded-full border border-emerald-200 bg-emerald-50 py-0.5 leading-tight text-emerald-700 ${text}`}
          title={t(`affinity.reasonHints.${reason}`, {
            count: row.features.author_in_history ?? 0,
          })}
        >
          {t(`affinity.reasons.${reason}`)}
        </span>
      ))}
    </div>
  );
}
